import React from "react";
import { ToastListType } from "../Toast";
import { Icons } from "contents/icons";
import { LottieLoading } from "components/lottie/LottieLoading";
import { Button } from "components/button/Button/Button";

export const ToastWrap = ({
  toast,
  toastClose,
}: {
  toast: ToastListType;
  toastClose: (id: string) => void;
}) => (
  <React.Fragment>
    <div className="content-box">
      <div className="title-box">
        {toast.type === "success" && <Icons.CheckCircle className="icon" />}
        {toast.type === "warning" && <Icons.AlertTriangle className="icon" />}
        {toast.type === "error" && <Icons.XCircle className="icon" />}
        {toast.type === "info" && <Icons.InfoCircle className="icon" />}
        {toast.type === "loading" && (
          <div className="loading">
            <LottieLoading size={16} padding="0.2rem" />
            {toast.loadingMessage && <p>{toast.loadingMessage}</p>}
          </div>
        )}
        {toast.type !== "loading" && (
          <p>{toast.type.charAt(0).toUpperCase() + toast.type.slice(1)}</p>
        )}
      </div>
      <p className="message">
        {toast.message.split("\n").map((message, index) =>
          index === 0 ? (
            <React.Fragment key={`${message}-${index}`}>
              {message}
            </React.Fragment>
          ) : (
            <React.Fragment key={`${message}-${index}`}>
              <br />
              {message}
            </React.Fragment>
          )
        )}
      </p>
      {toast.button !== null && (
        <Button
          size="small"
          type="solid"
          preIcon={toast.button.preIcon}
          postIcon={toast.button.postIcon}
          color={
            toast.type === "info" || toast.type === "loading"
              ? toast.color === "normal"
                ? "strong"
                : "normal"
              : "normal"
          }
          label={toast.button.label}
          onClick={(e) => {
            toast.button?.onClick(e);
            toastClose(toast.id);
          }}
        />
      )}
    </div>

    <Button
      color={
        toast.type === "info" || toast.type === "loading"
          ? toast.color === "normal"
            ? "strong"
            : "normal"
          : "normal"
      }
      type="text"
      size="small"
      width="2rem"
      onClick={() => toastClose(toast.id)}
      preIcon="XCloseMd"
    />
  </React.Fragment>
);
